import axios from 'axios';
import { API_URL, NEW_API_URL, BASE_URL, LAMBDA_API_URL } from '@karma/utils/constants/env';
import { X_PLATFORMS } from '@karma/utils/constants/axios';
import { v4 as uuidv4 } from 'uuid';
import { ITEMS } from 'consts/localStorage';
import { isClient } from 'functions/isClient';
import paramsSerializer from 'functions/paramsSerializer';
import { isMobile } from 'functions/isMobile';
import isMobileOrTablet from 'functions/isMobileOrTablet';
import { isIOS } from 'functions/isIOS';
import getOsVersion from 'functions/getOsVersion';
import { COOKIES } from 'consts/cookies';
import { getCookieValue } from 'functions/cookies';
import safeJsonParse from 'functions/safeJsonParse';

const ssrRubyApiInstance = axios.create({
  baseURL: process.env.REACT_APP_SSR_RUBY_API_URL || `https://${BASE_URL}`,
  paramsSerializer,
});

const ssrJavaApiInstance = axios.create({
  baseURL: process.env.REACT_APP_SSR_JAVA_API_URL || `https://${BASE_URL}`,
  paramsSerializer,
});

const newApiInstance = axios.create({
  baseURL: NEW_API_URL,
  paramsSerializer,
});

const oldApiInstance = axios.create({
  baseURL: API_URL,
  paramsSerializer,
});

const javaApiInstance = axios.create({
  baseURL: `https://${BASE_URL}/ws`,
  paramsSerializer,
});

const lambdaApiInstance = axios.create({
  baseURL: LAMBDA_API_URL,
  paramsSerializer,
});

const careersApiInstance = axios.create({
  baseURL: 'https://www.comeet.co/careers-api/2.0',
  paramsSerializer,
});

javaApiInstance.interceptors.response.use(
  response => response,
  error => Promise.reject(error.response),
);

const addCustomHeaders = config => {
  /* eslint-disable no-param-reassign */
  const token = isClient() ? localStorage.getItem(ITEMS.token) : null;
  const isMobilePlatform = isMobileOrTablet();

  if (!config.headers.authorization && token) {
    config.headers.authorization = `Bearer ${token}`;
  }

  if (process.env.REACT_APP_VERSION) {
    config.headers.common['X-Platform-Version'] = process.env.REACT_APP_VERSION;
  }

  if (isMobilePlatform) {
    const xMobileAgent = (() => {
      const cookieValueString = getCookieValue(COOKIES.xMobileAgent);
      const cookieValue = safeJsonParse(cookieValueString);

      if (cookieValue && typeof cookieValue === 'object') {
        return cookieValue;
      }

      return {
        app_version: '',
        device_type: isMobile() ? 'phone' : 'tablet',
        os_version: getOsVersion(),
        platform: isIOS() ? 'iphone' : 'android',
      };
    })();

    config.headers.common['X-Mobile-Agent'] = JSON.stringify(xMobileAgent);
    if (xMobileAgent.app_version) config.headers.common['X-Mobile-Version'] = xMobileAgent.app_version;
  }

  config.headers.common['x-request-id'] = uuidv4();
  config.headers.common['X-Platform'] = isMobilePlatform ? X_PLATFORMS.mobile : X_PLATFORMS.dashboard;

  return config;
  /* eslint-enable no-param-reassign */
};

ssrRubyApiInstance.interceptors.request.use(addCustomHeaders);
ssrJavaApiInstance.interceptors.request.use(addCustomHeaders);
newApiInstance.interceptors.request.use(addCustomHeaders);
oldApiInstance.interceptors.request.use(addCustomHeaders);
javaApiInstance.interceptors.request.use(addCustomHeaders);
lambdaApiInstance.interceptors.request.use(addCustomHeaders);

export {
  ssrRubyApiInstance,
  ssrJavaApiInstance,
  newApiInstance,
  oldApiInstance,
  javaApiInstance,
  lambdaApiInstance,
  careersApiInstance,
};
